import { z } from "zod"

export const ENVIRONMENTS = ["dev", "staging", "production"] as const
export type Environment = (typeof ENVIRONMENTS)[number]

export const RANGE_PRESETS = [
  "today",
  "last7d",
  "last30d",
  "last90d",
  "mtd",
  "qtd",
  "ytd",
] as const
export type RangePreset = (typeof RANGE_PRESETS)[number]

export const dateRangeSchema = z.union([
  z.object({ preset: z.enum(RANGE_PRESETS) }),
  z.object({ from: z.iso.datetime({ offset: true }), to: z.iso.datetime({ offset: true }) }),
])
export type DateRange = z.infer<typeof dateRangeSchema>

export const COMPARE_MODES = ["overlay", "smallMultiples", "table"] as const
export type CompareMode = (typeof COMPARE_MODES)[number]

export const MAX_CATEGORICAL_SERIES = 8

export const globalFiltersSchema = z.object({
  environments: z.array(z.enum(ENVIRONMENTS)).default([]),
  tenants: z.array(z.string()).default([]),
  includeChurned: z.boolean().default(false),
  range: dateRangeSchema.default({ preset: "last30d" }),
  granularity: z.enum(["auto", "day", "week", "month"]).default("auto"),
  compareMode: z.enum(COMPARE_MODES).default("overlay"),
  comparePrevious: z.boolean().default(false),
})
export type GlobalFilters = z.infer<typeof globalFiltersSchema>

export const DEFAULT_FILTERS: GlobalFilters = globalFiltersSchema.parse({})

export function resolveAutoGranularity(spanDays: number): "day" | "week" | "month" {
  if (spanDays <= 31) return "day"
  if (spanDays <= 180) return "week"
  return "month"
}
